import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "confirmation-dialog"
}
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { class: "actions" }

interface PropsType {
  show?: boolean;
  title?: string;
  message?: string;
  maxWidth?: string;
  buttonConfirm?: string;
  buttonCancel?: string;
  textAlign?: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'base-confirm',
  props: {
    show: { type: Boolean, default: false },
    title: { default: "Antenção" },
    message: { default: "Tem certeza desta ação?" },
    maxWidth: { default: "100%" },
    buttonConfirm: { default: "Sim" },
    buttonCancel: { default: "Não" },
    textAlign: { default: "center" }
  },
  emits: ["confirm", "cancel"],
  setup(__props: any) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    (__props.show)
      ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
          _createElementVNode("div", {
            class: "confirm-content shadow",
            style: _normalizeStyle({ maxWidth: __props.maxWidth })
          }, [
            (__props.title)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "title",
                  innerHTML: __props.title
                }, null, 8, _hoisted_2))
              : _createCommentVNode("", true),
            (__props.message)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: "message",
                  style: _normalizeStyle({ 'text-align': __props.textAlign }),
                  innerHTML: __props.message
                }, null, 12, _hoisted_3))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("button", {
                class: "btn btn-primary btn-md",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('confirm')))
              }, _toDisplayString(__props.buttonConfirm), 1),
              _createElementVNode("button", {
                class: "btn btn-md",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('cancel')))
              }, _toDisplayString(__props.buttonCancel), 1)
            ])
          ], 4)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})